import { useEffect, useRef, useState } from "react";

const toRad = (deg) => (deg * Math.PI) / 180;


export function useDeviceTilt() {
  const angles = useRef({ pitch: 0, roll: 0 });
  const neutral = useRef(null);

  useEffect(() => {
    const k = 0.5;

    const OFFSET_DEG = -0;
    const OFFSET_RAD = toRad(OFFSET_DEG);

    const onOrient = (e) => {
      const pitch = toRad(e.beta ?? 0);
      const roll = toRad(e.gamma ?? 0);

      if (neutral.current === null) {
        neutral.current = { pitch, roll };
      }

      const pitchDelta =
        pitch - neutral.current.pitch + OFFSET_RAD;

      const rollDelta =
        roll - neutral.current.roll;

      angles.current.pitch +=
        (pitchDelta - angles.current.pitch) * k;

      angles.current.roll +=
        (rollDelta - angles.current.roll) * k;
    };

    window.addEventListener("deviceorientation", onOrient, { passive: true });
    return () => window.removeEventListener("deviceorientation", onOrient);
  }, []);

  return () => angles.current;
}

// Doit être lancé en HTTPS sinon pas de data sur le gyro
export function GyroLogger() {
  const [angles, setAngles] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleOrientation = (e) => {
      setAngles({
        x: e.beta?.toFixed(2) ?? 0,
        y: e.gamma?.toFixed(2) ?? 0,
      });
    };

    window.addEventListener("deviceorientation", handleOrientation, { passive: true });
    return () => window.removeEventListener("deviceorientation", handleOrientation);

    
    
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 10,
        left: 10,
        background: "rgba(0,0,0,0.7)",
        color: "white",
        padding: "8px 12px",
        borderRadius: "8px",
        fontFamily: "monospace",
        zIndex: 9999,
      }}
    >
      <div>Pitch (X): {angles.x}°</div>
      <div>Roll&nbsp;&nbsp;(Y): {angles.y}°</div>
    </div>
  );
}